import { ref, watch } from 'vue'

// Supervisor Mode on the outreach pages: members of outreach_supervisor can read every
// draft, thread and message, not only those on their own mailboxes. Reading
// only -- the server keeps edits and sends scoped to send access, and ignores
// the flag for anyone outside the group.
//
// Remembered per browser so it survives opening a draft and coming back.
const KEY = 'outreachSupervisorMode'

function stored() {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch (e) {
    return false
  }
}

export const outreachSupervisorMode = ref(stored())

watch(outreachSupervisorMode, (on) => {
  try {
    localStorage.setItem(KEY, on ? '1' : '')
  } catch (e) {
    // Storage blocked: the toggle still works for this page load.
  }
})

export function isOutreachSupervisor(store) {
  return (store.state.auth.userGroups || []).some((g) => g.name === 'outreach_supervisor')
}

// Query params for the read endpoints supervisor mode widens. Mutations never
// send it.
export function supervisorModeParams() {
  return outreachSupervisorMode.value ? { supervisor_mode: 1 } : {}
}
